import { jsx } from "panel";
import { InputEl } from "common/components/input";
import { StepsType } from "./types";
const StepsColumn = ({
  steps,
  sel,
  comp,
  type
}) => {
  return /* @__PURE__ */ jsx("div", {
    sel
  }, /* @__PURE__ */ jsx("div", {
    sel: ".label"
  }, comp.helpers.getStepsLabelForType(type)), /* @__PURE__ */ jsx(InputEl, {
    sel: sel + `-input`,
    attrs: {
      type: `number`,
      "select-on-focus": true,
      min: `0`,
      max: `99`,
      "show-numeric-input-controls": true
    },
    props: { value: steps != null ? steps : 0 },
    on: {
      change: (ev) => comp.helpers.handleInputUpdate(ev, type, steps)
    },
    hook: {
      insert: ({ elm }) => {
        if (type === StepsType.Before) {
          comp.setBeforeInputRef(elm);
        }
      }
    }
  }));
};
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".number-of-steps-dropdown"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".title"
  }, "Steps"), /* @__PURE__ */ jsx("div", {
    sel: ".subtitle"
  }, "Choose the number of steps to show before and after the event."), /* @__PURE__ */ jsx("div", {
    sel: ".steps-container"
  }, /* @__PURE__ */ jsx(StepsColumn, {
    steps: this.attr(`committed-before-steps`),
    sel: ".before-steps",
    comp: this,
    type: StepsType.Before
  }), /* @__PURE__ */ jsx(StepsColumn, {
    steps: this.attr(`committed-after-steps`),
    sel: ".after-steps",
    comp: this,
    type: StepsType.After
  })));
}
